import cx from 'classnames'

import { endpoints } from 'store/api/yay/group'

import './style.scss'

const GroupCategoryBadge = ({
  categoryId,
  solid,
  className,
}: {
  categoryId: number
  solid?: boolean
  className?: string
}) => {
  const groupCategoriesRes = endpoints?.getGroupCategories?.useQueryState?.({})

  return (
    <div
      className={cx('GroupCategoryBadge', {
        'GroupCategoryBadge--solid': solid,
        [className]: className,
      })}
    >
      <div className="GroupCategoryBadge__label">
        {
          (groupCategoriesRes?.data ?? [])?.find?.(
            (groupCategory) => groupCategory.id === categoryId
          )?.name
        }
      </div>
    </div>
  )
}

export default GroupCategoryBadge
